import React, { useEffect, useRef, useState } from 'react'

import { useParams } from 'react-router-dom';
import VideoPlayer from 'components/ShakaPlayer/VideoPlayer';
import AdsVideoPlayer from 'components/ShakaPlayer/AdsVideoPlayer';
import axios from 'axios';
import menu from '../../assets/img/body/svg/reply_white_48dp.svg'

// import { getBrowser } from 'getBrowser';
import FairPlay from 'components/ShakaPlayer/FairPlay';
import { getBrowser } from 'getBrowser';

function Ep() {
    let { id, ep } = useParams();
    const infoRef = useRef()
    const adsRef = useRef()
    const datasRef = useRef()
    const [nextUrl, setNextUrl] = useState()
    const [previousUrl, setPreviousUrl] = useState()
    const licenseRef = useRef()
    const lastEpRef = useRef()
    const [poster, setPoster] = useState()
    const [uservip, setUserVip] = useState()
    const [linkads, setLinkAds] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [currentEp, setCurrentEp] = useState(parseInt(ep.split('.')[1]))
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    useEffect(() => {
        if (id && ep) {
            if (localStorage.getItem('auth')) {
                axios.post(`${process.env.REACT_APP_API_CONTENT2}/serie/episode`, {
                    vod_id: parseInt(id),
                    page: 'main'
                }, {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem('auth')}`
                    },
                }).then(result => {
                    infoRef.current = result.data.res_data
                    if(result.data.res_data.user_vip == 0){
                        adsRef.current = result.data.res_data.link_ads
                    }else{
                        adsRef.current = ''
                    }
                    if (ep === 'END') {
                        setCurrentEp(`${result.data.res_data.episode.length}`)
                    }
                    lastEpRef.current = result.data.res_data.episode.length
                    licenseRef.current = result.data.res_data.ch_name
                    setPoster(result.data.res_data.imgX1)
                    setUserVip(result.data.res_data.user_vip)
                    datasRef.current = result.data.res_data.episode.filter(data => data.ep_name == ep && data.premium == 1 || data.ep_name === 'END' && data.premium == 1)
                    const nextIndex = result.data.res_data.episode.findIndex(x => x.ep_name == ep) + 1
                    if (result.data.res_data.episode[nextIndex]?.premium == '1') {
                        setNextUrl(result.data.res_data.episode[nextIndex]?.ep_name)
                    }
                    setPreviousUrl(result.data.res_data.episode.findIndex(x => x.ep_name == ep))
                }).finally(() => {
                    // if (datasRef.current[0].ep_link.split('.').pop() == 'm3u8') {
                    //     datasRef.current[0].ep_link = datasRef.current[0].ep_link.replace('prod_mvhub_v2', 'prod_mvhub_v2_1')
                    // }
                    setIsLoading(false)
                })
            } else {
                axios.post(`${process.env.REACT_APP_API_CONTENT2}/guest/episode`, {
                    vod_id: parseInt(id),
                    page: 'guest',
                    device: getBrowser()
                }).then(result => {
                    infoRef.current = result.data.res_data
                    adsRef.current = result.data.res_data.link_ads
                    if (ep === 'END') {
                        setCurrentEp(`${result.data.res_data.episode.length}`)
                    }
                    lastEpRef.current = 2
                    licenseRef.current = result.data.res_data.ch_name
                    setPoster(result.data.res_data.imgX1)
                    setUserVip(result.data.res_data.user_vip)
                    datasRef.current = result.data.res_data.episode.filter(data => data.ep_name == ep && data.premium == 1)
                    const nextIndex = result.data.res_data.episode.findIndex(x => x.ep_name == ep) + 1
                    setNextUrl(result.data.res_data.episode[nextIndex]?.ep_name)
                    setPreviousUrl(result.data.res_data.episode.findIndex(x => x.ep_name == ep))
                })
                    .finally(() => {
                        // if (datasRef.current[0].ep_link.split('.').pop() == 'm3u8') {
                        //     datasRef.current[0].ep_link = datasRef.current[0].ep_link.replace('prod_mvhub_v2', 'prod_mvhub_v2_1')
                        // }
                        if (datasRef.current[0].premium == 1) {
                            setIsLoading(false)
                        }
                    })
            }
            
        }
    }, []);

    if (isLoading === false) {
        return (
            <div className='bg-blank'>
                {currentEp < lastEpRef.current &&
                    <>
                        {getBrowser() === 4 &&
                            <FairPlay
                                id={id}
                                url={datasRef.current[0].ep_link}
                                nextUrl={`/vdo/${id}/ep/${nextUrl}`}
                                previousUrl={`/vdo/${id}/ep/EP.${previousUrl}`}
                                lastEp={lastEpRef.current}
                                license={licenseRef.current}
                                ep={[id, datasRef.current[0]?.ep_id, params.play]}
                                poster={poster}
                                datas={infoRef}
                                linkads={adsRef}
                                uvip={uservip}
                            />
                        }
                        {getBrowser() !== 4 &&
                            <>
                                <a className="menu not-A" style={{ color: 'white' }} href={`/vdo/${id}`}><img src={menu} alt='menu' /></a>
                                {uservip == 1 &&
                                    <VideoPlayer
                                        id={id}
                                        url={datasRef.current[0].ep_link}
                                        nextUrl={`/vdo/${id}/ep/${nextUrl}`}
                                        previousUrl={`/vdo/${id}/ep/EP.${previousUrl}`}
                                        lastEp={lastEpRef.current}
                                        license={licenseRef.current}
                                        ep={[id, datasRef.current[0]?.ep_id, params.play]}
                                        poster={poster}
                                        datas={infoRef}
                                    />
                                }
                                {uservip != 1 &&
                                        <AdsVideoPlayer
                                        id={id}
                                        url={datasRef.current[0].ep_link}
                                        nextUrl={`/vdo/${id}/ep/${nextUrl}`}
                                        previousUrl={`/vdo/${id}/ep/EP.${previousUrl}`}
                                        lastEp={lastEpRef.current}
                                        license={licenseRef.current}
                                        ep={[id, datasRef.current[0]?.ep_id, params.play]}
                                        poster={poster}
                                        datas={infoRef}
                                        linkads={adsRef}
                                    />
                                }
                            </>
                        }
                    </>
                }
                {
                    currentEp >= lastEpRef.current &&
                    <>
                        {getBrowser() === 4 &&
                            <FairPlay
                                id={id}
                                url={datasRef.current[0].ep_link}
                                nextUrl={`/vdo/${id}/ep/EP.0`}
                                previousUrl={`/vdo/${id}/ep/EP.${previousUrl}`}
                                lastEp={lastEpRef.current}
                                license={licenseRef.current}
                                ep={[id, datasRef.current[0]?.ep_id, params.play]}
                                poster={poster}
                                datas={infoRef}
                                linkads={adsRef}
                                uvip={uservip}
                            />
                        }
                        {getBrowser() !== 4 &&
                            <>
                                <a className="menu not-A" style={{ color: 'white' }} href={`/vdo/${id}`}><img src={menu} alt='menu' /></a>
                                {uservip == 1 &&
                                    <VideoPlayer
                                        id={id}
                                        url={datasRef.current[0].ep_link}
                                        nextUrl={`/vdo/${id}/ep/EP.0`}
                                        previousUrl={`/vdo/${id}/ep/EP.${previousUrl}`}
                                        lastEp={lastEpRef.current}
                                        license={licenseRef.current}
                                        ep={[id, datasRef.current[0]?.ep_id, params.play]}
                                        poster={poster}
                                        datas={infoRef}
                                    />
                                }
                                {uservip != 1 &&
                                    <AdsVideoPlayer
                                    id={id}
                                    url={datasRef.current[0].ep_link}
                                    nextUrl={`/vdo/${id}/ep/EP.0`}
                                    previousUrl={`/vdo/${id}/ep/EP.${previousUrl}`}
                                    lastEp={lastEpRef.current}
                                    license={licenseRef.current}
                                    ep={[id, datasRef.current[0]?.ep_id, params.play]}
                                    poster={poster}
                                    datas={infoRef}
                                    linkads={adsRef}
                                    />
                                }
                            </>
                        }
                    </>
                }
            </div >
        )
    } else {
        return <div></div>
    }
}

export default Ep